import React, {Component} from 'react';
import {Redirect} from 'react-router-dom';
import {PostData} from '../services/PostData';
import {GetData} from '../services/GetData';
import {
  Row,
	Col,
	Card,
	CardHeader,
	CardBody,
	Modal, ModalHeader, ModalBody, ModalFooter
} from 'reactstrap';
import $ from 'jquery';
import ReactFileReader from 'react-file-reader';
import PLUSIMAGE from '../assets/noimage.jpg';
import AppPage from '../views/AppPage';
import Gallery from 'react-grid-gallery';
const GLOBAL = require('../Globals');

const styles = {
	sBox: {
	    position: 'absolute',
		top: '0px',
		right: '10px',
		width: '170px'
	},
	imgStyle : {
		padding:'10px',border : '1px solid #d8d8d8',margin : '10px',height : '120px'
	},
	plusImgStyle : {
		padding:'10px',border : '1px solid #d8d8d8',margin : '10px',backgroundColor : '#f1f1f1',cursor : 'pointer'
	},
	btnStyle : {
		position: 'absolute',
		top: '1px',
		right: '-17px',
		borderRadius: '24px',
		cursor : 'pointer'
	}
}

class Slider extends Component {
	
	/** set property value **/
	constructor(props){
		super(props);
		this.state = {
			_message : '',
			alertClass :'',
			files: [],
			files1 : [],
			dataView : [],
			dataList : [],
			editData : [],
			modal : false,
			showEditModal : false,
		}
		this.toggle = this.toggle.bind(this);
		this.toggleEdit = this.toggleEdit.bind(this);
		this.onChange = this.onChange.bind(this);
		this.onSubmit = this.onSubmit.bind(this);
		this.onUpdateSubmit = this.onUpdateSubmit.bind(this);
		this.handleClick = this.handleClick.bind(this);
		this.getFiles = this.getFiles.bind(this);
	}

	handleEditClick(id,e){
		this.setState({showEditModal : true,editId :id});
		var d = this.state.dataList;
		var index = d.findIndex(function(obj){
			return (obj.id == id);
		});
		this.setState({editData : d[index],image : d[index]['image'],name : d[index]['name'],url : d[index]['url']});
	}

	onChange(e){
		this.setState({[e.target.name] : e.target.value});
	}

	toggle(){
		this.setState({
			modal: !this.state.modal
		});
	}
	
	toggleEdit(){
		this.setState({
			showEditModal: !this.state.showEditModal
		});
	}
	
	getFiles(files){
		
		this.setState({files : files.base64});
		/*if(this.state.files.length > 0){
			for(var i=0;i<(files.base64).length;i++){
				this.state.files.push(files.base64[i]);
			}
			this.setState({files : this.state.files});
		}else{
			this.setState({ files: files.base64});
		}

		if(this.state.files1.length > 0){
			for(var i=0;i<files.length;i++){
				this.state.files1.push(files);
			}
			this.setState({files1 : this.state.files});
		}else{
			this.setState({ files1: files});
		}*/
	}
	
	handleRemove(index){

		this.state.files.splice(index,1);
		this.setState({files : this.state.files});
	}

	/** submit form **/
	onSubmit(e){
		$("#showLoader").show();
			PostData('slider/saveslider',this.state).then((result) => {
				$("#showLoader").hide();
				let responseJson = result;
				if(responseJson.status == '1' ){
					this.setState({
						_message:'Slider Added Successfully!..',
						alertClass:'alert alert-success',
						files : [],
						modal : false
					});
					this.getdata();
				}
				else{
					this.setState({
						_message:'Error',
						alertClass:'alert alert-danger'
					});
				}
			});
	}

	/** submit form **/
	onUpdateSubmit(e){
		$("#showLoader").show();
			PostData('slider/updateslider',this.state).then((result) => {
				$("#showLoader").hide();
				let responseJson = result;
				if(responseJson.status == '1' ){
					this.setState({
						_message:'Slider Updated Successfully!..',
						alertClass:'alert alert-success',
						files : [],
						showEditModal : false
					});
					this.getdata();
				}
				else{
					this.setState({
						_message:'Error',
						alertClass:'alert alert-danger'
					});
				}
			});
	}
	
	/** this function will be call when page loading **/
	componentDidMount() {
		 
		this.getdata();
	}
	
	getdata(){
		$("#showLoader").show();
		GetData('slider/getslider').then((result) => {
			$("#showLoader").hide();
			let responseJson = result;
			if(responseJson['status'] == 1){
				this.setState({
					dataView : responseJson['data'],
					dataList : responseJson['data']
				});
			}
		});
	}
	
	/** remove function **/
	handleClick(dd){
		
		this.state.id = dd;
		
		if (window.confirm("Do you want to Delete?")) {
      $("#showLoader").show();			
			PostData('slider/removeslider',this.state).then((result) => {
				$("#showLoader").hide();
				let responseJson = result;
				if(responseJson.status == '1'){
					this.setState({
						_message:'Slider Removed Successfullly',
						alertClass:'alert alert-success'
					});
					this.getdata();
				}
				else{
			
					this.setState({
						_message:'Error in Remove Slider',
						alertClass:'alert alert-danger'
					});
				}
			});
		}	
	}

	getValue(field){
		var d = this.state.editData;
		return d[field];
	}

	setValue(field,e){
		this.setState({[field] : e.target.value});
		var d = this.state.editData;
		d[field] = e.target.vlue;
		this.setState({editData : d});
	}
	
  render() {
	
		let IMAGES = [];
		this.state.dataView.map((item,i)=>{
			IMAGES.push({
				src : GLOBAL.BASE_URL+item.image,
				thumbnail : GLOBAL.BASE_URL+item.image,
				thumbnailWidth: 20,
				thumbnailHeight: 20,
				tags: [
					{value : <div>
						<button className="btn btn-info btn-xss" onClick={this.handleEditClick.bind(this,item.id)}><i className="fa fa-edit"></i></button>&nbsp;
						<button type="button" className="btn btn-danger btn-xss" onClick={this.handleClick.bind(this,item.id)}><i className="fa fa-remove"></i></button>
						</div> }
				],
				caption: item.name}) 
		});

    return (
			<div>
				<AppPage />
				<div className="animated fadeIn">
					<div className={this.state.alertClass}>
						{this.state._message}
					</div>
					<Row>
						<Col md={12}>
							<Card>
								<CardHeader>
									<strong>Sliders</strong>
									<button style={{float  :'right'}} className="btn btn-success btn-xs" onClick={this.toggle}>Add</button>
								</CardHeader>
								<CardBody>
									<Row>
										<Col md={12}>
											<Gallery images={IMAGES}/>
										</Col>
									</Row>
								</CardBody>
							</Card>
						</Col>
					</Row>
					<Modal isOpen={this.state.modal} toggle={this.toggle} className={this.props.className}>
						<ModalHeader toggle={this.toggle}>Add Slider</ModalHeader>
						<ModalBody>
							<Row>
								<Col md="3">
									<ReactFileReader fileTypes={[".png",".jpg",".jpeg"]} base64={true} handleFiles={this.getFiles}>
										<img src={this.state.files.length > 0 ? this.state.files : PLUSIMAGE} width="120px" style={styles.plusImgStyle} />
									</ReactFileReader>
								</Col>
								<Col md={9}>
									<Col md="12">
										<label>Text</label>
										<input type="text" name="name" className="form-control" onChange={this.onChange} />
									</Col>
									<Col md="12">
										<label>URL</label>
										<input type="text" name="url" className="form-control" onChange={this.onChange} />
									</Col>
									<Col md={12}>
										<button style={{float  :'right'}} className="btn btn-success btn-xs" onClick={this.onSubmit}>Save</button>
									</Col>
								</Col>
							</Row>
						</ModalBody>
					</Modal>
					<Modal isOpen={this.state.showEditModal} toggle={this.toggleEdit} className={this.props.className}>
						<ModalHeader toggle={this.toggleEdit}>Edit Slider</ModalHeader>
						<ModalBody>
							<Row>
								<Col md="3">
									<ReactFileReader fileTypes={[".png",".jpg",".jpeg"]} base64={true} handleFiles={this.getFiles}>
										<img src={this.state.files.length > 0 ? this.state.files : this.getValue('image')!='' ? GLOBAL.BASE_URL+this.getValue('image') : PLUSIMAGE} width="120px" style={styles.plusImgStyle} />
									</ReactFileReader>
								</Col>
								<Col md={9}>
									<Col md="12">
										<label>Text</label>
										<input type="text" name="name" className="form-control" onChange={this.onChange} value={this.getValue('name')} onChange={this.setValue.bind(this,'name')} />
									</Col>
									<Col md="12">
										<label>URL</label>
										<input type="text" name="url" className="form-control" onChange={this.onChange} value={this.getValue('url')} onChange={this.setValue.bind(this,'url')} />
									</Col>
									<Col md={12}>
										<button style={{float  :'right'}} className="btn btn-success btn-xs" onClick={this.onUpdateSubmit}>Update</button>
									</Col>
								</Col>
							</Row>
						</ModalBody>
					</Modal>
				</div>	
			</div>
		)
  }
}

export default Slider;



// WEBPACK FOOTER //
// ./src/Slider/Slider.js